// IMAGES IMPORT
import TAMALE_TACOS from "../assets/moments/tamales/TAMALE_TACOS.jpg"
import TAMALE_BREAKFAST_PLATE from "../assets/moments/tamales/TAMALE_BREAKFAST_PLATE.jpg"
import TAMALE_SKILLET from "../assets/moments/tamales/TAMALE_SKILLET.jpg"
import TANDT_BAKE from "../assets/moments/tamales/T&T_BAKE.jpg"
import MSC_TAMALE_BOWL from "../assets/moments/tamales/MSC_TAMALE_BOWL.jpg"
import MSC_TAMALE_QUESADILLA from "../assets/moments/tamales/MSC_TAMALE_QUESADILLA.jpg"
import TACO_CUPS from "../assets/moments/beans/TACO_CUPS.png"
import LOADED_BOWL from "../assets/moments/beans/LOADED_BOWL.png"
import BEAN_SALAD from "../assets/moments/beans/BEAN_SALAD.png"
import TOSTADAS from "../assets/moments/beans/TOSTADAS.jpg"
import MEXICAN_STYLE_PLATE from "../assets/moments/beans/MEXICAN_STYLE_PLATE_.png"
import BREAKFAST_BOWL from "../assets/moments/beans/BREAKFAST_BOWL.png"
import BEAN_AND_CHEESE_TACOS from "../assets/moments/beans/BEAN_AND_CHEESE_TACOS.png"
import SPICY_BEAN_TOAST from "../assets/moments/beans/SPICY_BEAN_TOAST.png"
import RICE_BOWL from "../assets/moments/rices/RICE_BOWL.png";
import RICE_STUFFED_PEPPERS from "../assets/moments/rices/RICE_STUFFED_PEPPERS.png";
import RICE_TACO_PLATE from "../assets/moments/rices/RICE_TACO_PLATE.png";
import RICE_AND_EGG_BOWL from "../assets/moments/rices/RICE_AND_EGG_BOWL.png";
import POLLO_ASADO_BOWL from "../assets/moments/rices/POLLO_ASADO_BOWL.png";
import POLLO_ASADO_WRAP from "../assets/moments/rices/POLLO_ASADO_WRAP.png";
import POBLANO_SKILLET from "../assets/moments/rices/POBLANO_SKILLET.png";
import POBLANO_TACOS from "../assets/moments/rices/POBLANO_TACOS.png";
import CHIPOTLE_BURRITO_BOWL from "../assets/moments/rices/CHIPOTLE_BURRITO_BOWL.png";
import CHIPOTLE_QUESADILLA from "../assets/moments/rices/CHIPOTLE_QUESADILLA.png";
import LOADED_RICE_CUP from "../assets/moments/rices/LOADED_RICE_CUP.png";
import RICE_CUP_TACOS from "../assets/moments/rices/RICE_CUP_TACOS.png";

export const recipeCards = [
    {
        title: "Tamale Tacos",
        imageUrl: TAMALE_TACOS,
        ingredients: [
            "San Miguel Green Salsa Tamale",
            "Corn tortillas",
            "Avocado slices",
            "White onion, chopped",
            "Cilantro",
        ],
        steps: [
            "Pan-sear tamale until crispy",
            "Warm tortillas until soft",
            "Slice, assemble, add toppings",
        ],
    },
    {
        title: "Tamale Breakfast Plate",
        imageUrl: TAMALE_BREAKFAST_PLATE,
        ingredients: [
            "San Miguel Green Salsa Tamale",
            "Fried egg",
            "Cotija cheese",
            "Salsa verde",
        ],
        steps: [
            "Heat tamale",
            "Top with fried egg",
            "Finish with cotija and salsa verde",
        ],
    },
    {
        title: "Tamale Skillet",
        imageUrl: TAMALE_SKILLET,
        ingredients: [
            "San Miguel Red Salsa Tamale",
            "Sunny-side-up egg",
            "Queso fresco",
            "Sliced jalapeño",
        ],
        steps: [
            "Heat tamale in skillet",
            "Add egg on top",
            "Finish with queso fresco and jalapeño",
        ],
    },
    {
        title: "T&T Bake",
        imageUrl: TANDT_BAKE,
        ingredients: [
            "San Miguel Red Salsa Tamale",
            "Tortilla chips",
            "Shredded cheese",
            "Mexican crema",
        ],
        steps: [
            "Heat tamale and break into chunks",
            "Layer over chips",
            "Melt cheese and drizzle crema",
        ],
    },
    {
        title: "MSC Tamale Bowl",
        imageUrl: MSC_TAMALE_BOWL,
        ingredients: [
            "San Miguel Mexican Street Corn Tamale",
            "Mexican crema",
            "Cotija cheese",
            "Chili powder",
        ],
        steps: [
            "Heat tamale",
            "Drizzle crema",
            "Top with cotija and chili powder",
        ],
    },
    {
        title: "MSC Tamale Quesadilla",
        imageUrl: MSC_TAMALE_QUESADILLA,
        ingredients: [
            "San Miguel Mexican Street Corn Tamale",
            "Flour tortilla",
            "Oaxaca or mozzarella cheese",
        ],
        steps: [
            "Heat tamale and slice",
            "Add to tortilla with cheese",
            "Toast until melted",
        ],
    },
    {
        title: "Taco Cups",
        imageUrl: TACO_CUPS,
        ingredients: [
            "San Miguel Charro Beans with Chorizo",
            "Corn tortillas",
            "White onion",
            "Cilantro",
        ],
        steps: [
            "Heat beans",
            "Fill warm tortillas",
            "Top with onion and cilantro",
        ],
    },
    {
        title: "Loaded Bowl",
        imageUrl: LOADED_BOWL,
        ingredients: [
            "San Miguel Charro Beans with Chorizo",
            "Cooked rice",
            "Avocado",
            "Lime",
        ],
        steps: [
            "Heat beans",
            "Serve over rice",
            "Top with avocado and lime",
        ],
    },
    {
        title: "Bean Salad",
        imageUrl: BEAN_SALAD,
        ingredients: [
            "San Miguel Street Corn Pinto & Black Beans",
            "Cherry tomatoes",
            "Cilantro",
            "Lime juice",
        ],
        steps: [
            "Heat or serve warm",
            "Mix with tomatoes and cilantro",
            "Finish with lime",
        ],
    },
    {
        title: "Tostadas",
        imageUrl: TOSTADAS,
        ingredients: [
            "San Miguel Street Corn Pinto & Black Beans",
            "Tostadas",
            "Mexican crema",
            "Cotija",
        ],
        steps: [
            "Heat beans",
            "Spread over tostadas",
            "Top with crema and cotija",
        ],
    },
    {
        title: "Mexican-Style Plate",
        imageUrl: MEXICAN_STYLE_PLATE,
        ingredients: [
            "San Miguel Mexican Black Beans",
            "White rice",
            "Avocado",
            "Lime",
        ],
        steps: [
            "Heat beans",
            "Serve over rice",
            "Top with avocado and lime",
        ],
    },
    {
        title: "Breakfast Bowl",
        imageUrl: BREAKFAST_BOWL,
        ingredients: [
            "San Miguel Mexican Black Beans",
            "Scrambled eggs",
            "Cilantro",
        ],
        steps: [
            "Heat beans",
            "Top with eggs",
            "Finish with cilantro",
        ],
    },
    {
        title: "Bean & Cheese Tacos",
        imageUrl: BEAN_AND_CHEESE_TACOS,
        ingredients: [
            "San Miguel Refried Pinto Beans with Jalapeño",
            "Corn tortillas",
            "Queso fresco",
        ],
        steps: [
            "Heat beans",
            "Spread into tortillas",
            "Top with queso fresco",
        ],
    },
    {
        title: "Spicy Bean Toast",
        imageUrl: SPICY_BEAN_TOAST,
        ingredients: [
            "San Miguel Refried Pinto Beans with Jalapeño",
            "Toasted bread",
            "Avocado",
        ],
        steps: [
            "Heat beans",
            "Spread on toast",
            "Top with avocado",
        ],
    },
    {
        title: "Rice Bowl",
        imageUrl: RICE_BOWL,
        ingredients: [
            "San Miguel Mexican Street Corn Rice",
            "Grilled chicken",
            "Cotija",
            "Lime",
        ],
        steps: [
            "Heat rice",
            "Top with chicken",
            "Finish with cotija and lime",
        ],
    },
    {
        title: "Rice Stuffed Peppers",
        imageUrl: RICE_STUFFED_PEPPERS,
        ingredients: ["San Miguel Mexican Street Corn Rice", "Bell peppers"],
        steps: [
            "Heat rice",
            "Stuff into peppers",
            "Serve warm",
        ],
    },
    {
        title: "Rice Taco Plate",
        imageUrl: RICE_TACO_PLATE,
        ingredients: [
            "San Miguel Red Rice with Veggies",
            "Ground beef or plant-based protein",
            "Tortillas",
        ],
        steps: [
            "Heat rice",
            "Serve with protein",
            "Build tacos",
        ],
    },
    {
        title: "Rice & Egg Bowl",
        imageUrl: RICE_AND_EGG_BOWL,
        ingredients: [
            "San Miguel Red Rice with Veggies",
            "Fried egg",
            "Cilantro",
        ],
        steps: [
            "Heat rice",
            "Top with egg",
            "Finish with cilantro",
        ],
    },
    {
        title: "Pollo Asado Bowl",
        imageUrl: POLLO_ASADO_BOWL,
        ingredients: [
            "San Miguel Pollo Asado Rice",
            "Avocado",
            "Pico de gallo",
        ],
        steps: [
            "Heat rice",
            "Top with avocado and pico",
        ],
    },
    {
        title: "Pollo Asado Wrap",
        imageUrl: POLLO_ASADO_WRAP,
        ingredients: [
            "San Miguel Pollo Asado Rice",
            "Flour tortilla",
            "Cheese",
        ],
        steps: [
            "Heat rice",
            "Wrap with cheese",
            "Toast lightly",
        ],
    },
    {
        title: "Poblano Skillet",
        imageUrl: POBLANO_SKILLET,
        ingredients: [
            "San Miguel Poblano Rice",
            "Sautéed mushrooms",
            "Queso fresco",
        ],
        steps: [
            "Heat rice",
            "Add mushrooms",
            "Top with queso fresco",
        ],
    },
    {
        title: "Poblano Tacos",
        imageUrl: POBLANO_TACOS,
        ingredients: [
            "San Miguel Poblano Rice",
            "Corn tortillas",
            "Crema",
        ],
        steps: [
            "Heat rice",
            "Fill tortillas",
            "Drizzle crema",
        ],
    },
    {
        title: "Chipotle Burrito Bowl",
        imageUrl: CHIPOTLE_BURRITO_BOWL,
        ingredients: [
            "San Miguel Peppers & Chipotle Rice",
            "Black beans",
            "Avocado",
        ],
        steps: [
            "Heat rice",
            "Top with beans and avocado",
        ],
    },
    {
        title: "Chipotle Quesadilla",
        imageUrl: CHIPOTLE_QUESADILLA,
        ingredients: [
            "San Miguel Peppers & Chipotle Rice",
            "Flour tortilla",
            "Cheese",
        ],
        steps: [
            "Fill tortilla with rice and cheese",
            "Toast until crispy",
        ],
    },
    {
        title: "Loaded Rice Cup",
        imageUrl: LOADED_RICE_CUP,
        ingredients: [
            "San Miguel Mexican Street Corn Rice Cup",
            "Avocado",
            "Hot sauce",
        ],
        steps: [
            "Heat cup",
            "Top with avocado and hot sauce",
        ],
    },
    {
        title: "Rice Cup Tacos",
        imageUrl: RICE_CUP_TACOS,
        ingredients: [
            "San Miguel Mexican Street Corn Rice Cup",
            "Corn tortillas",
            "Protein of choice",
        ],
        steps: [
            "Heat cup",
            "Spoon into tortillas",
            "Add protein",
        ],
    },
];